// Mixpanel tracking utility functions
// Type definitions for Mixpanel
declare global {
  interface Window {
    mixpanel: any
  }
}

// Safe wrapper for Mixpanel tracking with error handling
export const trackEvent = (
  eventName: string,
  properties?: Record<string, any>,
) => {
  try {
    if (typeof window !== 'undefined' && window.mixpanel) {
      window.mixpanel.track(eventName, {
        ...properties,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        page_title: document.title,
      })
    }
  } catch (error) {
    console.error('Mixpanel tracking error:', error)
  }
}

// Track CTA button clicks
export const trackCTAClick = (
  buttonName: string,
  section: string,
  destination?: string,
) => {
  trackEvent('CTA_Clicked', {
    button_name: buttonName,
    section: section,
    destination: destination,
  })
}

// Track Calendly link clicks (form submissions)
export const trackCalendlyClick = (buttonName: string, section: string) => {
  trackEvent('Calendly_Link_Clicked', {
    button_name: buttonName,
    section: section,
    form_type: 'calendly_booking',
    submission_timestamp: new Date().toISOString(),
  })
}

// Track video engagement
export const trackVideoPlay = (videoTitle: string, videoUrl: string) => {
  trackEvent('Video_Played', {
    video_title: videoTitle,
    video_url: videoUrl,
  })
}

export const trackVideoComplete = (
  videoTitle: string,
  videoUrl: string,
  timeWatched: number,
) => {
  trackEvent('Video_Completed', {
    video_title: videoTitle,
    video_url: videoUrl,
    time_watched: timeWatched,
  })
}

// Track section views
export const trackSectionView = (sectionName: string) => {
  trackEvent('Section_Viewed', {
    section_name: sectionName,
  })
}

// Identify user (call after email capture)
export const identifyUser = (
  email: string,
  properties?: Record<string, any>,
) => {
  try {
    if (typeof window !== 'undefined' && window.mixpanel) {
      window.mixpanel.identify(email)
      window.mixpanel.people.set({
        $email: email,
        signup_date: new Date().toISOString(),
        source_page: 'CAD Sync Landing Page',
        ...properties,
      })
    }
  } catch (error) {
    console.error('Mixpanel identify error:', error)
  }
}

// Track pricing plan selection
export const trackPricingPlanClick = (
  planName: string,
  billingCycle: string,
  price: number | null,
) => {
  trackEvent('Pricing_Plan_Selected', {
    plan_name: planName,
    billing_cycle: billingCycle,
    price: price,
  })
}

// Track external link clicks
export const trackExternalLink = (
  linkName: string,
  destination: string,
  section: string,
) => {
  trackEvent('External_Link_Clicked', {
    link_name: linkName,
    destination: destination,
    section: section,
  })
}
